//@ts-nocheck
import { useSchool } from 'features/school';
import React, { forwardRef } from 'react';
import { Helmet } from 'react-helmet';

type PageProps = React.ComponentPropsWithoutRef<'div'>;

const { PUBLIC_URL } = process.env;

const Page = forwardRef<HTMLDivElement, PageProps>(({ children, title = '' }, _forwardedRef) => {
  const { schoolName, uiSettings } = useSchool();

  const pageTitle = schoolName ? (title ? `${title} - ${schoolName}` : schoolName) : title ? title : 'Página não encontrada';

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        {Boolean(uiSettings && uiSettings.favIconUrl) ? (
          <link rel="icon" type="image/png" href={uiSettings.favIconUrl} />
        ) : (
          <link rel="icon" href={`${PUBLIC_URL}/favicon.ico`} />
        )}
      </Helmet>
      {children}
    </>
  );
});

export default Page;
